import { render } from "./UserViewLogged.vue?vue&type=template&id=16dfab61&scoped=true"
import script from "./UserViewLogged.vue?vue&type=script&lang=js"
export * from "./UserViewLogged.vue?vue&type=script&lang=js"

import "./UserViewLogged.vue?vue&type=style&index=0&id=16dfab61&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16dfab61"]])

export default __exports__